import Vue from 'vue';
import App from './App.vue';
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import './assets/css/fontface.css';
import './assets/css/style.css';
import './assets/css/lousa.css';
import VueOnsen from 'vue-onsenui'; // This already imports 'onsenui'
import VueMask from 'v-mask';
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router';

Vue.use(VueMask);
Vue.use(VueRouter);

VueOnsen.platform.select('android');

Vue.config.productionTip = false;
//import VueSocketIO from 'vue-socket.io'

Vue.use(VueOnsen);

//Vue.use(VueQrcodeReader);

// Vue.prototype.$menu_uri = "http://localhost:8082/api";
// Vue.prototype.$menu_img_uri = "http://localhost:8082/img/"
Vue.prototype.$menu_base = 'https://qrservice.com.br/';
// Vue.prototype.$menu_payment_uri = "https://mu8i12r7z1.execute-api.sa-east-1.amazonaws.com";

Vue.prototype.$menu_payment_uri =
  'https://ujlv0y5b45.execute-api.sa-east-1.amazonaws.com';
Vue.prototype.$menu_payment_link =
  'https://qrservice.com.br/assinatura';
Vue.prototype.$menu_uri = 'https://qrservice.com.br/api';
Vue.prototype.$menu_img_uri = 'https://qrservice.com.br/public/img/';

import Home from './components/Home.vue';
import SaibaComo from './components/SaibaComo.vue';
import MinhaLoja from './components/MinhaLoja.vue';
import Cardapio from './components/Cardapio.vue';
import QrCodes from './components/QrCodes.vue';
import Funcionalidades from './components/Funcionalidades.vue';
import Quiz from './components/Quiz.vue';
import Pagamentos from './components/Pagamentos.vue';
import Login from './components/Login.vue';
import Contato from './components/Contato.vue';
import Cadastro from './components/FormCadastro.vue';

const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: Login,
    },
    {
      path: '/Cadastro',
      component: Cadastro,
    },
    {
      path: '/Home',
      component: Home,
      children: [
        {
          path: '/',
          component: SaibaComo,
        },
        {
          path: '/MinhaLoja',
          component: MinhaLoja,
        },
        {
          path: '/Cardapio',
          component: Cardapio,
        },
        {
          path: '/QrCodes',
          component: QrCodes,
        },
        {
          path: '/Funcionalidades',
          component: Funcionalidades,
        },
        {
          path: '/Quiz',
          component: Quiz,
        },
        {
          path: '/Contato',
          component: Contato,
        },
        {
          path: '/Pagamentos',
          component: Pagamentos,
        },
      ],
    },
  ],
});

new Vue({
  render: (h) => h(App),
  router,
  vuetify,

  data() {
    return {};
  },
}).$mount('#app');
